'use client'

import { Builder } from '@builder.io/react'

import { Digioh } from './Digioh'

Builder.registerComponent(Digioh, {
  name: 'Digioh',
  noWrap: true,
  inputs: [
    {
      name: 'smartTagId',
      friendlyName: 'Smart Tag ID',
      type: 'string',
      defaultValue: '',
    },
  ],
})
